import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHubRouted4 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_17037_142872)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.6875 13V6.825L1.625 2.7625V4.875H0V0H4.875V1.625H2.7625L7.3125 6.175V13H5.6875ZM8.81563 5.3625L7.6375 4.18437L10.2375 1.625H8.125V0H13V4.875H11.375V2.7625L8.81563 5.3625Z",
				fill: "#EA80FC"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_17037_142872",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 13,
				height: 13,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHubRouted4);
export { ForwardRef as ReactComponent };
